export default "__VITE_ASSET__BrmKyqaf__"